import { render, staticRenderFns } from "./MyProjectContractsNewContractAction.vue?vue&type=template&id=13956412&scoped=true"
import script from "./MyProjectContractsNewContractAction.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectContractsNewContractAction.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectContractsNewContractAction.vue?vue&type=style&index=0&id=13956412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13956412",
  null
  
)

export default component.exports